import { useParams } from 'react-router-dom'
import ServiceNotifications from '../../Templates/shared/ServiceNotifications'

const Notification = () => {
    const { id: serviceID } = useParams()

    return (
        <ServiceNotifications
            serviceID={Number(serviceID)}
            onClose={() => {}}
        />
    )
}

export default Notification
